import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@els/els-react--icon';
import { Button } from '@els/els-react--button';

import './EditorControls.scss';

function EditorControls({ onCancel, onClear, onTransfer, transferButtonDisabled, transferButtonLabel }) {
  return (
    <section className="u-els-background-color-n0 u-els-padding-1x u-els-width-10o10 u-els-display-inline-block">
      <div className="u-els-float-right o-els-flex-layout editor-button-container">
        <Button
          type="link"
          size="small"
          onClick={onClear}
          data-e2e="structure-editor-clear"
          className="o-els-flex-layout__item u-els-color-text e2e-structure-editor-clear">
          Clear
          <Icon a11y={{ name: 'clear' }} id="editor-icon-clear-btn" className="u-els-margin-left-1o2 u-els-color-linkblue" sprite="Trash" />
        </Button>
        <Button
          type="tertiary"
          size="small"
          onClick={onCancel}
          data-e2e="structure-editor-cancel"
          className="o-els-flex-layout__item e2e-structure-editor-cancel">
          <Icon a11y={{ name: 'Cancel' }} id="editor-icon-cancel-btn" isVisible isTextFirst sprite="Close">
            Cancel
          </Icon>
        </Button>
        <Button
          data-e2e="structure-editor-transfer"
          size="small"
          onClick={onTransfer}
          type="primary"
          data-e2e="structure-editor-transfer"
          className="o-els-flex-layout__item e2e-structure-editor-transfer"
          disabled={transferButtonDisabled}>
          <Icon a11y={{ name: transferButtonLabel }} id="editor-icon-transfer-btn" isVisible isTextFirst sprite="ChevronRight">
            {transferButtonLabel}
          </Icon>
        </Button>
      </div>
    </section>
  );
}

EditorControls.defaultProps = {
  onCancel: () => {},
  onClear: () => {},
  onTransfer: () => {},
  transferButtonLabel: '',
};

EditorControls.propTypes = {
  onCancel: PropTypes.func,
  onClear: PropTypes.func,
  onTransfer: PropTypes.func,
  transferButtonDisabled: PropTypes.bool,
  transferButtonLabel: PropTypes.string,
};

export default EditorControls;
